import { base } from "@components/card/CardButton.styles";
import { headerColor, greys } from "@clockwise/web-commons/src/styles/color.styles";
export {
  header as tipHeader,
  body as tipBody,
} from "@clockwise/web-commons/src/components/tutorial-tip/TutorialTip.styles";

export const headerContainer = {
  display: "flex",
  alignItems: "center",
  marginBottom: 16,
};

export const autopilotIcon = {
  htmlColor: headerColor,
  style: {
    width: 20,
    height: 20,
    flexShrink: 0,
  },
};

export const apToggleText = {
  marginBottom: 16,
};

export const h2 = {
  marginBottom: 0,
  marginLeft: 8,
};

export const toggleContainer = {
  marginBottom: 10,
};

export const learnMoreContainer = {
  marginTop: 10,
};

export const settingsToggle = {
  display: "flex",
  alignItems: "center",
  paddingLeft: 28,
  color: greys.blueGrey,
  fontSize: 14,
  cursor: "pointer",
};

export const dropArrow = {
  htmlColor: greys.blueGrey,
  style: {},
};

export const enabledBy = {
  color: greys.slate,
  fontSize: 12,
  marginBottom: 12,
};

export const nonUserOrganizerInviteButton = {
  ...base,
  marginTop: 10,
  width: "initial",
};

export const styles = {
  apToggleText,
};
